import React from 'react'
import { useEffect, useState } from 'react';
import ApiUrl from '../../../configTools/apiUrl';

import { Link } from 'react-router-dom'

const NavBar = () => {
  const [menu,setMenu] = useState([]);
  useEffect(() => {
    fetch(ApiUrl.API_URL_Navigation)
    .then(res=>res.json())
    .then(data =>{
      let putdata = [];
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        if(element.parentid === 0){
          putdata.push(element);
        }
      }
      setMenu(putdata);
    });
  },[])
  return (
    <div className='main_navbar_wrapper'>
      <div className='main_navbar_container'>
        <ul className='main_navbar'>
        {
            menu.map(mitem=>{
              return(
                <li className='main_navbar_item' key={mitem.id}>
                  <Link to={mitem.url}><button>{mitem.name}</button></Link>
                  {mitem.children.length > 0 &&
                    <div>
                      <ul className='sub_navbar'>
                        {
                          mitem.children.map(child=>{
                            return(
                              <Link to={child.url} key={child.id}><li>{child.name}</li></Link>
                            );
                          })
                        }
                      </ul>
                    </div>
                  }
                </li>
              )
            })
          }
        </ul>
      </div>
    </div>
  )
}

export default NavBar
